import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppServiceService } from '../../app-service.service';
import { postPageAnimate } from '../../animation/animate';
import { ActivatedRoute } from '@angular/router';
import { UiService } from '../../ui.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss'],
  animations: [postPageAnimate],
  host: { '[@postPageAnimate]': '' }
})
export class PostComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<boolean> = new Subject();
  element:any;
  post:any;
  public screen:any = {
    'width' : '1920',
    'height': '1080'
  };

  constructor(
    private app:AppServiceService,
    private route: ActivatedRoute,
    private UI: UiService
  ) {
    this.app.positionMenuTop.next(true);
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
    });
    this.app.blackStyle.next(false);
    
    //this.api.get
    this.element = this.app.elementPost;

    this.app.showLeftPanel.next(true);
    //that menu show in app
    this.app.normalMenu.next(true);
  }

  animateContent(){
    this.UI.animateDownBlog();
  }

  ngOnInit() {
      //screen
      this.screen = this.app.screen;
      this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
        this.screen = this.app.screen;
      })

    setTimeout(() => {
      this.app.title.next('NEWS');
      this.app.titleLeftPanel.next(true); 
      this.app.activeMenu.next(true);
    }, 1500);
    setTimeout(() => {
      //fixed full size svg background image
      this.element = {
        'height': '100%',
        'width': '100%',
        'x': 0,
        'y': 0,
      }
    }, 2000);
  }

  ngOnDestroy(){
    this.app.positionMenuTop.next(false);
    this.app.titleLeftPanel.next(false);
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');

    setTimeout(() => {
      this.app.title.next('');
    },500);
    
    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/blog/post/post.component.ts